class ProfessionalActionsSticky extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.sentinel = null;
    this.minWidth = 1024;
    this.handleIntersect = this.handleIntersect.bind(this);
  }

  connectedCallback() {
    if (window.innerWidth < this.minWidth) return;

    const container = this.querySelector('.professional-actions-container');
    if (!container) return;

    this.sentinel = document.createElement('div');
    this.sentinel.style.position = 'absolute';
    this.sentinel.style.top = '100%';
    this.sentinel.style.width = '1px';
    this.sentinel.style.height = '1px';
    container.parentNode.insertBefore(this.sentinel, container.nextSibling);

    this.observer = new IntersectionObserver(this.handleIntersect, { threshold: 0 });
    this.observer.observe(this.sentinel);
    this.container = container;
  }

  handleIntersect(entries) {
    entries.forEach(entry => {
      if (window.innerWidth >= this.minWidth) {
        if (!entry.isIntersecting) {
            const header = document.querySelector('header');
          const headerHeight = header ? header.offsetHeight : 0;
          this.container.style.top = `${headerHeight}px`;
          this.container.classList.add('sticky-visible');
        } else {
          this.container.classList.remove('sticky-visible');
          this.container.style.top = '0';
        }
      } else {
        this.container.classList.remove('sticky-visible');
        this.container.style.top = '0';
      }
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.sentinel) this.sentinel.remove();
  }
}

customElements.define('professional-actions-sticky', ProfessionalActionsSticky);